import { useTranslations } from 'next-intl';

import PageBuilder from '@commons/pagebuilder';
import WebformDrawer from '@commons/pagebuilder/webforms/Drawer';

import { AIIA_WEBFORM_ID } from '@/pagebuilder/webforms';

import styles from './index.module.scss';

/**
 * Header ContactUsMenu component.
 *
 * Renders the appropriate webform in a drawer.
 */

const ContactUsMenu = () => {
  const t = useTranslations('header');

  const webformId = AIIA_WEBFORM_ID.ContactUs;
  const renderedForm = PageBuilder.renderWebform(webformId, { inDrawer: true });

  return (
    <WebformDrawer
      webformId={webformId}
      triggerProps={{
        label: t('cta'),
        variant: 'secondary',
        className: styles.contactUs,
      }}
    >
      {renderedForm}
    </WebformDrawer>
  );
};

export default ContactUsMenu;
